import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchPackages({ payload }) {
  try {
    const res = yield call(API.fetchCompanyPackages, payload);
    const { data } = res;
    yield put(actions.fetchPackagesSuccess(data));
  } catch (err) {
    yield put(actions.fetchPackagesFailure(err?.response?.data));
  }
}

export function* handleFetchCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompaniesFailure(err?.response?.data));
  }
}

export function* handleAllCommodities() {
  try {
    const res = yield call(API.fetchAllCommodities);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* packageListSaga() {
  yield takeLatest(actions.fetchPackages.type, handleFetchPackages);
  yield takeLatest(actions.fetchCompanies.type, handleFetchCompanies);
  yield takeLatest(actions.fetchCommodities.type, handleAllCommodities);
}
